import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpSortState', pkpSortState);

    /**
     * @author flzemke.btc
     * @ngInject
     */
    function pkpSortState() {
        return {
            restrict: 'E',
            scope: {
                newOrder: '=',
                currentOrder: '=',
                reverseOrder: '='
            },
            template: require('app/_directives/pkp-sort-state.directive.html')
        };
    }
})();
